import { RootState } from 'shared/store/store'
import {
  ILabel,
  ILabelDetailed,
  LabelProcessingTypeEnum,
} from 'Modules/Communication/shared/models/Labels'

export interface SystemState {
  communication: {
    labels: {
      data: ILabel[]
      error: unknown
      loading: boolean
      processing: LabelProcessingTypeEnum | null
      processingError: string | null
      details: ILabelDetailed | null
    }
  }
}

export const getInboxLabels = (state: RootState) => state.communication.labels
